import React, { useState, useCallback } from 'react';
import { Card, CardBody, CardHeader, CardTitle, Button } from 'reactstrap';
import { Icon } from 'js/components';
import AddProductManagerForm from './ProductManagerForm';
import styles from './ProductManagerList.module.scss';
import { searchUsersForProductManager } from 'js/actions/product-manager-actions';
import { connect } from 'react-redux';
import { faPlus } from '@fortawesome/pro-regular-svg-icons';
import { faHeadSideGear } from '@fortawesome/pro-light-svg-icons';
import ProductManagerCard from './ProductManagerCard';

function ProductManagerList({
  userGroup,
  onAddProductManager,
  onRemoveProductManager,
  searchUsersForProductManager,
}) {
  const [isAddingProductManager, setIsAddingProductManager] = useState(false);

  const handleAddProductManagerClick = useCallback(() => {
    setIsAddingProductManager(true);
  }, []);

  const handleAddProductManager = useCallback(
    (values) => {
      onAddProductManager(values);
      setIsAddingProductManager(false);
    },
    [onAddProductManager]
  );

  const handleCancelAddProductManager = useCallback(() => {
    setIsAddingProductManager(false);
  }, []);

  const handleSearchUsers = useCallback(
    async (query) => {
      const trimmedQuery = query.trim();
      if (trimmedQuery.length === 0) {
        return [];
      }

      try {
        const result = await searchUsersForProductManager(
          trimmedQuery,
          userGroup?.id
        );
        return result || [];
      } catch (error) {
        console.error('Failed to search users:', error);
        return [];
      }
    },
    [searchUsersForProductManager, userGroup?.id]
  );

  return (
    <Card>
      <CardHeader>
        <div className="action-items">
          <Button color="primary" onClick={handleAddProductManagerClick}>
            <Icon icon={faPlus} className="btn-icon-left" />
            Add
          </Button>
        </div>
        <CardTitle tag="h5">Product Managers</CardTitle>
      </CardHeader>
      <CardBody>
        {isAddingProductManager && (
          <AddProductManagerForm
            userGroup={userGroup}
            onSubmit={handleAddProductManager}
            onCancel={handleCancelAddProductManager}
            onSearch={handleSearchUsers}
          />
        )}
        <div className={styles['product-manager-list']}>
          {userGroup.product_managers?.length > 0 ? (
            <div className={styles['product-manager-items']}>
              {userGroup.product_managers.map((pm) => (
                <ProductManagerCard
                  key={pm.id}
                  productManager={pm}
                  onRemoveProductManager={onRemoveProductManager}
                />
              ))}
            </div>
          ) : (
            !isAddingProductManager && (
              <div className="media text-muted">
                <Icon
                  icon={faHeadSideGear}
                  size="4x"
                  className="mr-3"
                  fixedWidth
                />
                <div className="media-body">
                  <p>No product managers assigned to this group yet.</p>
                  <p>
                    Product managers help coordinate and manage the user group's
                    capabilities and assessments.
                  </p>
                </div>
              </div>
            )
          )}
        </div>
      </CardBody>
    </Card>
  );
}

export default connect(null, {
  searchUsersForProductManager,
})(ProductManagerList);
